// Logged-in app page: clip-pack detail (routes/PackDetail.tsx). Keep keys in sync with
// pl/appPackDetail.ts.
export const appPackDetail = {
  crumb: 'Clips',
  readOnly: 'read-only',
  more: 'More',
  menu: {
    select: 'Select',
    moveToCollection: 'Move to collection',
    merge: 'Merge with another pack',
    delete: 'Delete pack',
  },
  upload: {
    files: 'files {done} of {total}',
  },
  delete: {
    ask: 'Delete “{name}”?',
    rowClips: 'Clips',
    rowDuration: 'Duration',
    rowCollection: 'Collection',
  },
  toolbar: {
    review: 'Review clips',
    addFiles: 'Add files',
    markReviewed: 'Mark as reviewed',
    unmarkReviewed: 'Undo “reviewed”',
    reviewFailed: 'Could not save the pack state.',
  },
  clip: {
    openPreview: 'Open clip {n}',
    deleteTitle: 'Delete clip',
    deleteAsk_one: 'Delete {n} clip?',
    deleteAsk_few: 'Delete {n} clips?',
    deleteAsk_many: 'Delete {n} clips?',
    deleteAsk: 'Delete {n} clips?',
    deleteCancel: 'Cancel',
  },
  selection: {
    enter: 'Select',
    cancel: 'Cancel',
    selectClip: 'Select clip {n}',
    selected_one: '{n} selected',
    selected_few: '{n} selected',
    selected_many: '{n} selected',
    move: 'Move',
    copy: 'Copy',
    delete: 'Delete clips',
    deleteCount: 'Delete ({n})',
  },
  transfer: {
    moveTitle: 'Move clips to another pack',
    copyTitle: 'Copy clips to another pack',
    target: 'Target pack',
    targetPlaceholder: 'Pick a pack',
    emptyTitle: 'There is no other ready pack.',
    cancel: 'Cancel',
    confirmMove: 'Move clips',
    confirmCopy: 'Copy clips',
    failed: 'Could not move the clips.',
  },
  preview: {
    close: 'Close the preview',
    errorTitle: 'Could not play the clip.',
  },
  toast: {
    marked: 'Marked as reviewed.',
    clipsDeleted_one: 'Deleted {n} clip.',
    clipsDeleted_few: 'Deleted {n} clips.',
    clipsDeleted_many: 'Deleted {n} clips.',
    clipsDeleted: 'Deleted {n} clips.',
    moved_one: 'Moved {n} clip.',
    moved_few: 'Moved {n} clips.',
    moved_many: 'Moved {n} clips.',
    moved: 'Moved {n} clips.',
    copied_one: 'Copied {n} clip.',
    copied_few: 'Copied {n} clips.',
    copied_many: 'Copied {n} clips.',
    copied: 'Copied {n} clips.',
    deleteFailed: 'Could not delete the clips.',
  },
  empty: {
    short: 'No clips',
  },
  error: {
    title: 'Could not load the pack',
    retry: 'Try again',
  },
}
